import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import { type ReactNode, useMemo } from "react";
import type { User } from "../models/index";

export function UserAvatar({
  className,
  icon,
  size = "xs",
  user,
}: Readonly<{
  className?: string;
  icon?: ReactNode;
  size?: "xs" | "s" | "m" | "l";
  user?: User;
}>) {
  const avatarFallbackString = useMemo(() => {
    return String(
      user?.name?.[0]?.trim() || user?.email?.[0]?.trim() || "",
    ).toUpperCase();
  }, [user]);

  return (
    <Avatar
      className={cn(
        size === "xs"
          ? "size-[20px]"
          : size === "s"
            ? "size-[24px]"
            : size === "m"
              ? "size-8"
              : "size-[100px]",
        className,
      )}
    >
      {icon || (
        <>
          <AvatarImage src={user?.picture} alt={user?.name} />
          <AvatarFallback>{avatarFallbackString}</AvatarFallback>
        </>
      )}
    </Avatar>
  );
}
